// Your priorities — the directives sent TO the person signed in, on the desktop. The
// bell's "Priority from …" link lands here for PMs and the office (Ryan, Sep 30 2026:
// they used to land on the Executive hub's send form). Executives send from the
// Executive page; this page never sends.
import React, { useState } from 'react';
import AdminLayout from './AdminLayout';
import DirectiveCards from '../../components/DirectiveCards';

export default function MyPriorities() {
  const [count, setCount] = useState(null);
  return (
    <AdminLayout>
      <div className="admin-page-header">
        <div>
          <h1 className="admin-page-title">🔴 Your priorities</h1>
          <p className="admin-page-sub">{count == null ? 'Reading…' : count === 0 ? 'Nothing waiting on you right now.' : `${count} waiting on you — tap one to acknowledge, reply or mark it done.`}</p>
        </div>
      </div>
      <div style={{ maxWidth: 760 }}>
        <DirectiveCards onCount={setCount} />
      </div>
    </AdminLayout>
  );
}
